module.exports = __webpack_public_path__ + "static/media/bouquet-lg.de5b92ab.svg";